module.exports = __webpack_public_path__ + "img/American-Credit-Tips-On-How-To-Sell-Financing.ab8edf2.png";